import First from "../Activity/actvity images/s1.jpg";
import Second from "../Activity/actvity images/s2.jpg";
import Third from "../Activity/actvity images/s3.jpg";

export default [
  {
    urls: First,
  },
  {
    urls: Second,
  },
  {
    // title: "Third Slide",
    // description: "This is the Third slider Image of our carousel",
    urls: Third,
  },
  // {
  //   // title: "Fourth Slide",
  //   // description: "This is the Fourth slider Image of our carousel",
  //   urls: "https://mdbootstrap.com/img/Photos/Slides/img%20(133).jpg",
  // },
  // {
  //   // title: "Fifth Slide",
  //   // description: "This is the Fifth slider Image of our carousel",
  //   urls: "https://mdbootstrap.com/img/Photos/Slides/img%20(147).jpg",
  // },
  // {
  //   title: "Sixth Slide",
  //   description: "This is the Sixth slider Image of our carousel",
  //   urls: "https://mdbootstrap.com/img/Photos/Slides/img%20(105).jpg",
  // },
  // {
  //   title: "Seventh Slide",
  //   description: "This is the Seventh slider Image of our carousel",
  //   urls: "https://mdbootstrap.com/img/Photos/Slides/img%20(102).jpg",
  // },
];